import React from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Avatar
} from '@mui/material';
import { StatusBadge } from '../common';
import { User } from '../../types';

interface UserDetailsCardProps {
  user: User;
  elevation?: number;
  padding?: number;
}

/**
 * A reusable component for displaying user details
 */
const UserDetailsCard: React.FC<UserDetailsCardProps> = ({ 
  user, 
  elevation = 1,
  padding = 2
}) => {
  return (
    <Paper elevation={elevation} sx={{ p: padding }}>
      <Typography variant="h6" gutterBottom>User Information</Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Avatar 
          sx={{ 
            width: 40, 
            height: 40, 
            fontSize: 18, 
            bgcolor: 'primary.main',
            mr: 2
          }}
        >
          {user.name.charAt(0)}
        </Avatar>
        <Box>
          <Typography variant="body1">{user.name}</Typography>
          <Typography variant="body2" color="text.secondary">{user.email}</Typography>
        </Box>
      </Box>
      
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Department</Typography>
        <Typography variant="body1">{user.department || 'Not specified'}</Typography>
      </Box>
      
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Role</Typography>
        <StatusBadge status={user.role} />
      </Box>
    </Paper>
  );
};

export default UserDetailsCard;
